<template>
  <div class="onboarding-second-steps-component">
    <section v-if="!isAuthenticated" class="component-disabled">
      <div class="title">
        <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.SECOND.@TITLE")) }}</h3>
        <QIcon name="icon-f-image" class="welcome-icon" />
      </div>
      <h4>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.SECOND.@SUBTITLE")) }}</h4>
    </section>
    <section v-if="isAuthenticated">
      <div class="title">
        <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.SECOND.@TITLE")) }}</h3>
        <QIcon name="icon-f-image" class="welcome-icon" />
      </div>
      <h4>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.SECOND.@SUBTITLE")) }}</h4>
      <div class="time">
        <span>
          {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.SECOND.@TIME")) }}
          <QIcon name="icon-f-clock" class="welcome-icon" />
        </span>
      </div>
      <div class="action text-center">
        <QBtn
          color="secondary full-width"
          class="btn-navigation-half"
          :label="$t('ETAB.BUTTONS.@CONTINUE')"
          no-caps
          @click="handleContinueSecondStep()"
        />
      </div>
    </section>
  </div>
</template>

<script>
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";

  export default {
    props: {
      isAuthenticated: { type: Boolean, default: false },
    },
    emits: ["onAction"],
    methods: {
      handleContinueSecondStep() {
        TrackingManager.addEvent({
          event: FIREBASE_EVENTS.FUNNEL_SECOND_STEP_START,
        });
        TrackingManager.addEvent({
          event: FIREBASE_EVENTS.FUNNEL_SECOND_STEP,
          params: {
            step: "step1_start",
          },
        });
        this.$emit("onAction");
      },
    },
  };
</script>

<style lang="scss">
  .onboarding-second-steps-component {
    padding: 0 15px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      h3 {
        line-height: 1.18;
        flex: 1;
        margin: 0;
      }
    }

    h4 {
      line-height: 1.18;
      color: $primary-medium;
    }

    .time {
      text-align: right;
      color: $secondary;
      margin-bottom: 15px;
    }

    .welcome-icon {
      margin-left: 5px;
      font-size: 24px;
    }

    .component-disabled {
      opacity: 0.35;
    }
  }
</style>
